import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';

const ProtectedRoute=()=>{
    const location = useLocation();
    const auth= sessionStorage.getItem('token');
    return auth? <Outlet/> :<Navigate to="/login" replace state={{ from: location }} />
}

export default ProtectedRoute;